// Default icon per report type, used by the sidebar reports list and the report page
// title. Editors can override it per report (report.icon with customized: true).
export const REPORT_TYPE_ICONS = {
    'top-performing': 'ph:medal',
    'custom-groups-comparison': 'ph:stack',
    'launch': 'ph:rocket',
}

export const getReportIcon = (type) => REPORT_TYPE_ICONS[type] || 'ph:chart-line-up'

export const DEFAULT_REPORT_ICON_COLOR = 'text-secondary'

// The icon a report actually shows: its picked icon + color once customized, else the type default.
export const getReportDisplayIcon = (report) => {
    const icon = report?.icon
    if (icon?.customized && icon?.value) {
        return { value: icon.value, color: icon.color || 'text-muted-foreground' }
    }
    return { value: getReportIcon(report?.type), color: DEFAULT_REPORT_ICON_COLOR }
}
